// TODO:: Use MemberType in places instead of UserType. Later extend from this if additional
export var MemberType = /*#__PURE__*/ function(MemberType) {
    MemberType["Native"] = "NATIVE";
    MemberType["External"] = "EXTERNAL";
    MemberType["ExternalPartner"] = "EXTERNAL_PARTNER";
    MemberType["Partner"] = "PARTNER";
    return MemberType;
}({});
export var RoleType = /*#__PURE__*/ function(RoleType) {
    RoleType["Vendor"] = "VENDOR";
    RoleType["Customer"] = "CUSTOMER";
    return RoleType;
}({});
export var RateCardSourceType = /*#__PURE__*/ function(RateCardSourceType) {
    RateCardSourceType["USER"] = "USER";
    RateCardSourceType["ROLE"] = "ROLE";
    RateCardSourceType["TEAM"] = "TEAM";
    return RateCardSourceType;
}({});
export var LoginPolicyType = /*#__PURE__*/ function(LoginPolicyType) {
    LoginPolicyType["RocketlaneAuth"] = "ROCKETLANE_AUTH";
    LoginPolicyType["MagicLink"] = "MAGIC_LINK";
    LoginPolicyType["Idp"] = "IDP";
    return LoginPolicyType;
}({});
export var CompanyType = /*#__PURE__*/ function(CompanyType) {
    CompanyType["CustomerPartner"] = "EXTERNAL_PARTNER";
    CompanyType["Customer"] = "CUSTOMER";
    CompanyType["Partner"] = "PARTNER";
    CompanyType["Vendor"] = "VENDOR";
    return CompanyType;
}({});
export var UserType = /*#__PURE__*/ function(UserType) {
    UserType["Native"] = "NATIVE";
    UserType["External"] = "EXTERNAL";
    UserType["Partner"] = "PARTNER";
    UserType["CustomerPartner"] = "EXTERNAL_PARTNER";
    UserType["CustomerPortalBot"] = "CUSTOMER_PORTAL_BOT";
    return UserType;
}({});
/**
 * @deprecated
 *
 * Use `ProjectPermissionSetType` and `AccountPermissionSetType` instead
 */ export var PermissionSetType = /*#__PURE__*/ function(PermissionSetType) {
    PermissionSetType[PermissionSetType["AccountAdmin"] = 1] = "AccountAdmin";
    PermissionSetType[PermissionSetType["ProjectOwner"] = 2] = "ProjectOwner";
    PermissionSetType[PermissionSetType["Collaborator"] = 3] = "Collaborator";
    PermissionSetType[PermissionSetType["CustomerCollaborator"] = 4] = "CustomerCollaborator";
    PermissionSetType[PermissionSetType["CustomerChampion"] = 5] = "CustomerChampion";
    PermissionSetType[PermissionSetType["Observer"] = 6] = "Observer";
    PermissionSetType[PermissionSetType["SuperUser"] = 7] = "SuperUser";
    PermissionSetType[PermissionSetType["AccountVendorCollaborator"] = 8] = "AccountVendorCollaborator";
    PermissionSetType[PermissionSetType["AccountCustomerCollaborator"] = 10] = "AccountCustomerCollaborator";
    PermissionSetType[PermissionSetType["PartnerAdmin"] = 11] = "PartnerAdmin";
    PermissionSetType[PermissionSetType["PartnerMember"] = 12] = "PartnerMember";
    PermissionSetType[PermissionSetType["PartnerCollaborator"] = 13] = "PartnerCollaborator";
    PermissionSetType[PermissionSetType["IcertisPmAccountRole"] = 100] = "IcertisPmAccountRole";
    PermissionSetType[PermissionSetType["CustomerPartner"] = 20] = "CustomerPartner";
    PermissionSetType[PermissionSetType["CustomerPartnerCollaborator"] = 22] = "CustomerPartnerCollaborator";
    return PermissionSetType;
}({});
export var UserStatus = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Inactive"] = "INACTIVE";
    UserStatus["Invited"] = "INVITED";
    UserStatus["Passive"] = "PASSIVE";
    return UserStatus;
}({});
export var IntegrationStatus = /*#__PURE__*/ function(IntegrationStatus) {
    IntegrationStatus["Connected"] = "CONNECTED";
    IntegrationStatus["NotConnected"] = "NOT_CONNECTED";
    return IntegrationStatus;
}({});
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_FORMAT = 'DD MMM YY, hh:mm A';
export const DISPLAY_FORMAT_WITHOUT_TIME = 'DD MMM YY';
export const DATE_INPUT_DISPLAY_FORMAT = 'DD MMM YYYY';
export var OrderType = /*#__PURE__*/ function(OrderType) {
    OrderType["AllTasks"] = "all_tasks";
    OrderType["ProjectList"] = "project_list";
    OrderType["ProjectTaskList"] = "project_task_list";
    OrderType["DrilldownList"] = "drilldown_list";
    return OrderType;
}({});
